import { LocalisationDictionary } from './localisationDictionary';

export const enUS: LocalisationDictionary = {
    i18n: {
        global: {
            done: 'Done',
            redo: 'Redo',
            undo: 'Undo',
            exitSecondaryCta: 'Not finished? Go back',
            linkLoading: 'creating link...',
            linkHelper: 'Link copied to clipboard',
            linkError: 'error occurred - unable to create link',
            linkCta: 'COPY',
            checkoutSecondaryCta: 'View in AR',
            checkoutPrimaryCta: 'Add to Cart',
            saveText: 'Save for later',
            totalPrice: 'Total price',
            finalise: 'Finalise and purchase',
            unknownErrorHeading: 'An unknown error has occurred',
            unknownErrorBody: 'Try closing the app and reopening it again',
            shareDrawerHeader: 'Save and share',
            urlTabHeader: 'URL',
            qrTabHeader: 'QR',
            arDrawerHeader: 'View in AR',
            qrLoading: 'Generating QR Code',
            qrErrorHeading: 'Failed to generate QR code',
            qrErrorMessage: 'Please close this panel and try again',
            qrCodeDialogHeader:
                "Scan this QR code on your mobile device to see what you've designed in your home",
            incompatibleDeviceDialogHeader: 'Your device is not AR compatible',
            arErrorDialogHeader: 'Failed to launch AR',
            buttonText: 'View in room',
            buttonExplainerText: 'See this product in your home with Augmented Reality',
            basketSavingsText: 'You save {percent}% ({discount})',
        },
        configuration: {
            defaultEmptySelection: 'None',
            incompatible: 'These options come with extra changes',
            selected: 'Selected',
            loadingStatus: 'Please wait',
            updatingConfiguration: 'Updating configuration and selections',
            changeAlert: {
                many: "We've made  {numberOfChanges} changes to accommodate this choice",
                one: "We've made  1 change to accommodate this choice",
            },
            initialLoading: 'Loading configurator',
            middleLoading: 'Almost there...',
            finalLoading: 'Almost there...',
            exitPrimaryCta: 'Exit',
            exitTitle: 'Return to your configuration at any time',
            checkoutTitle: 'Your vanity configuration',
            shareHelpText:
                'This link will only open the configuration as it looks now. If you make any changes you will need to get a new link.',
            shareHeading:
                'Use this link to return to this configuration and share it with friends and family',
            mailtoSubject: 'Your Vanity Unit Configurator Link',
            mailtoBody:
                'Thanks for using our vanity unit configurator. The link to access your configuration is below:',
            unknownErrorBody: 'Try closing the configurator and reopening it again',
            returnToPlanner: 'Return to configurator',
            rendererErrorHeading: '3D Render Unavailable',
            rendererErrorBody:
                "Something’s gone wrong. Choose a different option or use 'Undo' to restore your previous selection.",
        },
        space: {
            initialLoading: 'Please wait while we load this set into your space',
            middleLoading: 'Almost there, please bear with us',
            finalLoading:
                'This is taking longer than expected, try connecting to wifi for the best experience',
            exitPrimaryCta: 'Exit 3D space planner',
            exitTitle: 'Return to your space at any time',
            shareHelpText:
                'This link will only open the space as it looks now. If you make any changes you will need to get a new link.',
            shareHeading:
                'Use this link to return to this space and share it with friends and family',
            mailtoSubject: 'Your Moda Link',
            mailtoBody:
                'Thanks for using our 3D space planner, the link to access your layout is below.',
            unknownErrorBody: 'Try closing the planner and reopening it again',
            returnToPlanner: 'Return to 3D Space Planner',
        },
    },
};
